import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["DASH"],
  endpoints: (builder) => ({
    getDashboardSummary: builder.query({
      query: ({ branchId = "", fromDate = "", toDate = "", branchNumericId = "" } = {}) => ({
        url: "/dashboard/summary",
        method: "GET",
        params: { branchId, fromDate, toDate, branchNumericId },
      }),
      providesTags: [{ type: "DASH", id: "SUMMARY" }],
      keepUnusedDataFor: 30,
    }),

    // ✅ NEW: Monthly trend (consolidated / branch / branch+category + categoryMonthly)
  getDashboardMonthlyTrend: builder.query({
  query: ({
    branchId = "",
    fromDate = "",
    toDate = "",
    date = "",

    categoryId = "",
    category = "",

    // existing
    includeCategoryBreakdown = "1",
    categoryTop = "12",

    // ✅ NEW (product + design breakdown)
    productId = "",
    product = "",
    productBreakdown = "", // "", "0", "1" (backend me auto-on for category unless "0")
    productTop = "12",

    designBreakdown = "0", // "1" to get designTotals
    designTop = "12",
  } = {}) => ({
    url: "/dashboard/monthly-trend",
    method: "GET",
    params: {
      branchId,
      fromDate,
      toDate,
      date,
      categoryId,
      category,
      includeCategoryBreakdown,
      categoryTop,

      productId,
      product,
      productBreakdown,
      productTop,

      designBreakdown,
      designTop,
    },
  }),
  providesTags: [{ type: "DASH", id: "MONTHLY_TREND" }],
  keepUnusedDataFor: 30,
}),

  }),
});

export const {
  useGetDashboardSummaryQuery,
  useGetDashboardMonthlyTrendQuery,
} = dashboardApi;

export default dashboardApi;
